'use strict';

$.spinner().start();

var shadefinderADAbutton = $('#shadefinder-ADA-button').val();
$('.shadefinderInter').append('<button class="hidden retry-vto-sf btn btn-primary">' + $('.shadefinderInter').attr('data-retry') + '</button>');

/**
 * Fill all elements regarding shade information
 * @param {*} shadeData 
 * @param {*} shadeNameElt 
 * @param {*} clickShadeElt 
 * @param {*} squareShadeElt 
 */
function applyShade(shadeData, shadeNameElt, clickShadeElt, squareShadeElt) {
    $(clickShadeElt)
        .attr('data-id', shadeData.id)
        .attr('data-value', shadeData.id)
        .attr('data-attr-value', shadeData.shadeID)
        .attr('aria-label', shadefinderADAbutton + ' ' + shadeData.shadeName)
        .attr('data-shadeOOS', shadeData.shadeOOS);
    $(shadeNameElt).text(shadeData.shadeName);
    $(squareShadeElt).attr('fill', shadeData.colorCode);
    if (shadeData.shadeOOS) {
        $(clickShadeElt).append('<span class="strock-line"></span>');
    }
}

window.ymkAsyncInit = function () {
    var e = document.getElementById('threshold');
    var countrycheck = $('#threshold').attr('data-country').toLowerCase();
    document.getElementById('btn-shadeFinderStart').style.display = 'none';

    var initParameters = {
        shadeFinderVersion: 'v4',
        disable2ColorComparison: true,
        hideAllButtonsOnResult: true,
        shadeFinderDeltaEThreshold: e.value,
        skinSmoothStrength: 33,
        shadeFinderResultVersion: 'v2',
        language: countrycheck,
        showShadeFinderLogo: false,
        userConsent: 'agree'
    };

    // Device type tablets Ipad Pro Ipad mini
    var windowSize = $(window).width();
    var windowHeight = $(window).height();

    if (windowSize >= 500) {
        initParameters.width = 500;
        initParameters.height = 619;
    } else {
        initParameters.showShadeFinderLogo = true;
        if ($('.shadefinderStand').length) {
            initParameters.width = windowSize;
            initParameters.height = windowHeight - ($('header').height()) + 2;
            window.YMK.addEventListener('closed', function () {
                var attrUrl = $('.shadefinderStand').attr('data-url');
                var idProduct = $('.shadefinderStand').attr('data-master');

                $('.custom-shade-search').hide();
                $(location).attr('href', attrUrl + '?pid=' + idProduct);
            });
        } else {
            initParameters.width = windowSize;
            initParameters.height = windowHeight - ($('.header-iframe').height()) + 2;

            window.YMK.addEventListener('closed', function () {
                $('.custom-shade-search').hide();
                $('.retry-vto-sf').removeClass('hidden');
            });
        }
    }

    // Init SF module
    window.YMK.init(initParameters);
    if (windowSize < 500) {
        $('body').addClass('lock-body');
        if ($('.shadefinderStand').length) {
            $('body').removeClass('lock-body');
        }
    }


    $.spinner().stop();
    if ($("#optin-vto-shadefiner").length) {
        $("#optin-vto-shadefiner").modal("show");

        $(".button-optin-submit").on("click", function () {
            $("#optin-vto-shadefiner").modal("hide");
            window.YMK.openShadeFinder();
        })
    } else {
        window.YMK.openShadeFinder();
    }

    if ($('.shadefinderSephora').length) {
        window.YMK.addEventListener('backToLive', function () {
            initParameters.showShadeFinderLogo = false;
            window.YMK.init(initParameters);
            $('.custom-shade-search').show();
        });
        window.YMK.addEventListener('enterTakePhoto', function () {
            initParameters.showShadeFinderLogo = true;
            window.YMK.init(initParameters);
            $('.custom-shade-search').hide();
        });
        window.YMK.addEventListener('opened', function () {
            initParameters.showShadeFinderLogo = true;
            window.YMK.init(initParameters);
        });
        window.YMK.addEventListener('shadeFinderComplete', function (r) {
            if (windowSize > 500) {
                initParameters.showShadeFinderLogo = false;
                window.YMK.init(initParameters);
            }
            $('#dev_tools2').text('').text('shade-found:' + JSON.stringify(r));
            var jsonshadevalue = $('#dev_tools').html();
            var parseJsonData = JSON.parse(jsonshadevalue);
            var idvalue = r.recommendations;
            var shadeId = [];
            var colorvalue = [];
            var shadevalue = [];
            var shadeOOS = [];
            var shadeSephoraUrls = [];
            var shadeProductUrls = [];
            Object.keys(parseJsonData).map(function (idVariant) {
                for (let index = 0; index < idvalue.length; index++) {
                    if (idVariant == idvalue[index].matched.skuId) {
                        shadeId.push(idVariant);
                        colorvalue.push(parseJsonData[idVariant].colorCode);
                        shadevalue.push(parseJsonData[idVariant].shadeName);
                        shadeOOS.push(parseJsonData[idVariant].shadeOOS);
                        if (parseJsonData[idVariant].urlSephora) {
                            shadeSephoraUrls.push(parseJsonData[idVariant].urlSephora);
                        }
                        if (parseJsonData[idVariant].urlSite) {
                            shadeProductUrls.push(parseJsonData[idVariant].urlSite);
                        }
                    }
                }
            })
            window.YMK.enableCompare();

            $('#IDshadenumber').html(shadeId);
            $('.skintone-subtitle-index').empty().html('hex ' + colorvalue[0]);
            $('.skintone-subtitle-pfcolor-prop').empty().html(shadevalue[0]);
            $('#threshold').val(shadeId[0]);

            var nbShade = 3;
            // Hide shade if necessary
            if (!shadeId[1]) {
                $('.skintone-circle-1').hide();
                nbShade--;
            }

            if (!shadeId[2]) {
                $('.skintone-circle-3').hide();
                nbShade--;
            }

            var $skintoneClick1 = $('.skintone-click1'),
                $skintoneClick2 = $('.skintone-click2'),
                $skintoneClick3 = $('.skintone-click3');
            if (shadeOOS[1]) {
                $skintoneClick1.attr('data-shadeOOS', shadeOOS[1]);
                $skintoneClick1.append('<span class="strock-line"></span>');
            }
            if (shadeOOS[0]) {
                $skintoneClick2.attr('data-shadeOOS', shadeOOS[0]);
                $skintoneClick2.append('<span class="strock-line"></span>');
            }
            if (shadeOOS[2]) {
                $skintoneClick3.attr('data-shadeOOS', shadeOOS[2]);
                $skintoneClick3.append('<span class="strock-line"></span>');
            }

            $skintoneClick1.attr('data-value', shadeId[1]);
            $skintoneClick2.attr('data-value', shadeId[0]);
            $skintoneClick3.attr('data-value', shadeId[2]);

            if (shadeSephoraUrls.length) {
                $skintoneClick1.attr('data-url-sephora', shadeSephoraUrls[1]);
                $skintoneClick2.attr('data-url-sephora', shadeSephoraUrls[0]);
                $skintoneClick3.attr('data-url-sephora', shadeSephoraUrls[2]);
            } else if (shadeProductUrls.length) {
                $skintoneClick1.attr('data-url-product', shadeProductUrls[1]);
                $skintoneClick2.attr('data-url-product', shadeProductUrls[0]);
                $skintoneClick3.attr('data-url-product', shadeProductUrls[2]);
            }

            $('.skintone-shadename1').text(shadevalue[1]);
            $('.skintone-shadename2').text(shadevalue[0]);
            $('.skintone-shadename3').text(shadevalue[2]);

            $('.skintone-wrapper').show();
            $('.matching-wrapper').show();
            $('.square1 circle').attr('fill', colorvalue[1]);
            $('.square2 circle').attr('fill', colorvalue[0]);
            $('.square3 circle').attr('fill', colorvalue[2]);
            $('.skintone-click2').trigger('click', [shadeId, colorvalue]).addClass('click-first-button');

            var dataUrl = $(".gtmurl").attr("data-url");
            dataUrl = dataUrl + '?products=' + shadeId.slice(0, nbShade);

            $.ajax({
                url: dataUrl,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    dataLayer.push(data.productListGtm);
                    if (data.productListGtm.ecommerce.impressions[0]) {
                        var productName = data.productListGtm.ecommerce.impressions[0].name;
                        var vtoSite = $(".gtmsite").attr("data-site");

                        dataLayer.push({
                            'event': 'shade_finder_result',
                            'sf_product_name': productName,
                            'sf_site_name': vtoSite,
                        });
                    }
                },
                error: function () {
                }
            });

            var dataUrl2 = $("#dev_tools_updated").attr("data-url");
            dataUrl2 = dataUrl2
                + '?products=['
                + shadeId[0]
                + ','
                + shadeId[1]
                + ','
                + shadeId[2]
                + ']';

            $.ajax({
                url: dataUrl2,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    $('.skintone-click1').attr('aria-label', data.ressources + " " + shadevalue[1] + " " + data.productslist[1].variant);
                    $('.skintone-click2').attr('aria-label', data.ressources + " " + shadevalue[0] + " " + data.productslist[0].variant);
                    $('.skintone-click3').attr('aria-label', data.ressources + " " + shadevalue[2] + " " + data.productslist[2].variant);
                },
                error: function (err) {
                    console.log('dataUrl2 err', err);
                }
            });
        });
    } else {
        window.YMK.addEventListener('backToLive', function () {
            initParameters.showShadeFinderLogo = true;
            $('.custom-shade-search').show();
        });
        window.YMK.addEventListener('enterTakePhoto', function () {
            initParameters.showShadeFinderLogo = false;
            $('.custom-shade-search').hide();
        });
        window.YMK.addEventListener('shadeFinderComplete', function (data) {
            var matchedProductIds = [];
            var productIds = [];
            // Get recommendations from Perfect Corp
            var recommendations = data.recommendations;
            var productListIds = JSON.parse($('#product-list-ids').html());
            // Check each PC recommandations
            for (var i = 0; i < recommendations.length; i++) {
                // Check if product recommended exists on SFCC
                if (recommendations[i].matched) {
                    for (var j = 0; j < productListIds.length; j++) {
                        if (recommendations[i].matched.skuId === productListIds[j].id) {
                            matchedProductIds.push(productListIds[j]);
                            productIds.push(productListIds[j].id);
                        }
                    }
                }
            }

            window.YMK.enableCompare();
            $('.skintone-subtitle-pfcolor-prop').empty().html(matchedProductIds[0].shadeName);

            var nbShade = 3;
            // Best shade
            applyShade(matchedProductIds[0], '.skintone-shadename2', '.skintone-click2', '.square2 circle');
            $('.skintone-click2').trigger('click').addClass('click-first-button');
            // Hide shade if necessary
            if (!matchedProductIds[1]) {
                $('.skintone-circle-1').hide();
                nbShade--;
            } else {
                applyShade(matchedProductIds[1], '.skintone-shadename1', '.skintone-click1', '.square1 circle');
            }

            if (!matchedProductIds[2]) {
                $('.skintone-circle-3').hide();
                nbShade--;
            } else {
                applyShade(matchedProductIds[2], '.skintone-shadename3', '.skintone-click3', '.square3 circle');
            }

            $('.skintone-wrapper').show();
            $('.matching-wrapper').show();

            var dataUrl = $(".gtmurl").attr("data-url") + '?products=' + productIds.slice(0, nbShade);

            $.ajax({
                url: dataUrl,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    dataLayer.push(data.productListGtm);
                    if (data.productListGtm.ecommerce.impressions[0]) {
                        var productName = data.productListGtm.ecommerce.impressions[0].name;
                        var vtoSite = $(".gtmsite").attr("data-site");

                        dataLayer.push({
                            'event': 'shade_finder_result',
                            'sf_product_name': productName,
                            'sf_site_name': vtoSite,
                        });
                    }
                },
                error: function () {
                }
            });
        });
    }

}

$(document).on('click', '.retry-vto-sf', function () {
    window.YMK.openShadeFinder();
    $('.retry-vto-sf').addClass('hidden');
});